module.exports = __webpack_public_path__ + "static/img/icon_94_move.0489ae8e.png";